require('./bootstrap');

import {
    createApp
} from 'vue'
import Toaster from '@meforma/vue-toaster';
import mitt from 'mitt';

import 'solana-wallets-vue/styles.css';
import '../css/wallet.css';
import '../css/toaster.css';

const emitter = mitt();

import BgGlobal from './components/BgGlobal.vue'
import Spinner from './components/Spinner.vue'
import App from './App.vue'
const appElement = document.querySelector('#app')
const app = createApp(App, {
    ...appElement.dataset
})

app.config.globalProperties.emitter = emitter
app.component('bg-global', BgGlobal)
app.component('spinner', Spinner)

app
    .use(Toaster, {
        'position': 'top',
        'duration': 3500
    })
    .mount('#app')
